// extracted by mini-css-extract-plugin
export default {"container":"src-views-index__container--FhlqO"};